// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"640":"c46fb025","855":"1f699e61"}[chunkId] + ".css";
};